import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const RouterLink = (props) => {
  const { className, children, onClick = () => {} } = props;

  const handleClick = () => {
    window.scrollTo(0, 0);
    onClick();
  };

  return (
    <NavLink
      {...props}
      activeClassName={cx('active')}
      className={cx(className, 'link')}
      onClick={handleClick}
    >
      <span className={cx('text')}>
        {children}
      </span>
    </NavLink>
  );
};

RouterLink.propTypes = {
  className: PropTypes.any,
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
};

export default RouterLink;
